import * as React from 'react'
import { tryCatch } from '../../utils/tryCatch'
import { ActionBoxPlayback } from './playback'
import { MultiplePlaybackData } from '../../selectors/component/actionBoxComponentSelectors'
import { AtfTreatmentProps } from '../../reducers/features'

interface IMultiplePlaybackProps extends MultiplePlaybackData, AtfTreatmentProps { duration?: number }

export const MultiplePlayback = tryCatch(({ playbackDataList, isRetail, playerConfigData,
                                            atfTreatment, duration}: IMultiplePlaybackProps) => {
  if (!playbackDataList.length) {
    return null
  }

  return <React.Fragment>
    {playbackDataList.map((data, idx) => {
      const props = {
        duration,
        playbackData: data,
        playerConfigData,
        isRetail,
        isStartOver: idx === 1, // Start Over button is always second one for live events
        atfTreatment
      }
      return <ActionBoxPlayback key={`action-box-playback-${idx}`} {...props} />
    })}
  </React.Fragment>
})
